/**
 * O relógio e o rascunho da consulta aberta — trilha T5a.
 *
 * O tempo é derivado de `iniciadoEm` e das pausas, nunca guardado como
 * contador: assim sobrevive a recarregar a página e a trocar de aparelho.
 */

import type { RespostaDaFicha } from './tipos';

export interface PausaDoAtendimento {
    id: string;
    de: string;
    /** Ausente: a pausa ainda está correndo. */
    ate?: string;
}

export interface RascunhoDaFicha {
    respostas: Record<string, RespostaDaFicha>;
    atualizadoEm: string;
}

/** A consulta aberta de quem está logado — o que acende a pílula da topbar. */
export interface AtendimentoEmAndamento {
    id: string;
    paciente: string;
    iniciadoEm: string;
    pausado: boolean;
}

/** O mesmo mínimo que a `reabrir_atendimento` da `0083` cobra. */
export const MOTIVO_MINIMO_PARA_REABRIR = 5;

export function estaPausado(pausas: PausaDoAtendimento[]): boolean {
    const ultima = pausas[pausas.length - 1];
    return Boolean(ultima && !ultima.ate);
}

/** Segundos de consulta até o instante `ate`, descontadas as pausas. */
export function segundosDeConsulta(iniciadoEm: string, pausas: PausaDoAtendimento[], ate: number): number {
    const inicio = new Date(iniciadoEm).getTime();
    const bruto = Math.max(0, ate - inicio);
    const parado = pausas.reduce((soma, p) => {
        const de = Math.max(inicio, new Date(p.de).getTime());
        const fim = Math.min(ate, p.ate ? new Date(p.ate).getTime() : ate);
        return soma + Math.max(0, fim - de);
    }, 0);
    return Math.floor(Math.max(0, bruto - parado) / 1000);
}

/** "1h 05min" ou "12min". Zero-padding só onde ajuda a ler. */
export function duracaoEscrita(segundos: number): string {
    const minutos = Math.round(segundos / 60);
    const horas = Math.floor(minutos / 60);
    return horas > 0 ? `${horas}h ${String(minutos % 60).padStart(2, '0')}min` : `${minutos}min`;
}

/** O dia civil em São Paulo, `YYYY-MM-DD` — é nele que o banco mede "hoje". */
export function diaEmSaoPaulo(instante: string | number): string {
    return new Date(instante).toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });
}
